// extracted by mini-css-extract-plugin
export default {"main":"whatIsIt_main__JjM0F","container":"whatIsIt_container__ZnKnS","link":"whatIsIt_link__4n1tt","question":"whatIsIt_question__OnARh","answer":"whatIsIt_answer__f3wjz"};